module.exports = {
    serviceUrl: 'https://prh-cfe-prod-web-01.azurewebsites.net'
    //serviceUrl: 'https://localhost:44315'
};
